import { render, staticRenderFns } from "./Portfolio.vue?vue&type=template&id=2cbaad56&scoped=true&"
import script from "./Portfolio.vue?vue&type=script&lang=ts&"
export * from "./Portfolio.vue?vue&type=script&lang=ts&"
import style0 from "./Portfolio.vue?vue&type=style&index=0&id=2cbaad56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cbaad56",
  null
  
)

export default component.exports